"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragonWhelp_SwipeAbilityHandler = exports.DragonWhelp_SwipeActorAbilityFactory = exports.DragonWhelp_SwipeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class DragonWhelp_SwipeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DragonWhelp_Swipe;
        this.__typeName = "DragonWhelp_Swipe";
    }
}
exports.DragonWhelp_SwipeAbilityArgs = DragonWhelp_SwipeAbilityArgs;
let DragonWhelp_SwipeActorAbilityFactory = class DragonWhelp_SwipeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DragonWhelp_Swipe", "OneEnemies", 0);
    }
};
DragonWhelp_SwipeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DragonWhelp_Swipe")
], DragonWhelp_SwipeActorAbilityFactory);
exports.DragonWhelp_SwipeActorAbilityFactory = DragonWhelp_SwipeActorAbilityFactory;
let DragonWhelp_SwipeAbilityHandler = class DragonWhelp_SwipeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 110)
            ]
        });
    }
};
DragonWhelp_SwipeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DragonWhelp_Swipe)
], DragonWhelp_SwipeAbilityHandler);
exports.DragonWhelp_SwipeAbilityHandler = DragonWhelp_SwipeAbilityHandler;
